
<shared-avatar-update
*ngIf="sessionData"
[img]="sessionData.user?.avatar" id="button_change_user_avatar"
[load]="upload$ | async"
(file)="onSubmitUserAvatar($event)">
</shared-avatar-update>